import { render, staticRenderFns } from "./LastHeadlineButton.vue?vue&type=template&id=02de3dea&scoped=true"
import script from "./LastHeadlineButton.vue?vue&type=script&lang=js"
export * from "./LastHeadlineButton.vue?vue&type=script&lang=js"
import style0 from "./LastHeadlineButton.vue?vue&type=style&index=0&id=02de3dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02de3dea",
  null
  
)

export default component.exports